const t = () => ({ tooltipVariants: {
  primary: {
    backgroundColorName: "BLACK",
    textColorName: "WHITE"
  },
  secondary: {
    backgroundColorName: "WHITE",
    textColorName: "BLACK"
  }
} });
export {
  t as default
};
//# sourceMappingURL=arrow-tooltip.js.map
